// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6016":"9810235e3ec5d04f","7682":"b28dbedefafc3f91"}[chunkId] + ".css";
};